export const FILTER_CREATIVE_CREATED_BY = 'createdBy';
export const FILTER_CREATIVE_TYPES = 'creativeTypes';
export const FILTER_CREATIVE_LANGUAGES = 'languages';
export const FILTER_CREATIVE_LENGTH = 'length';
export const FILTER_CREATIVE_MEDIA_TYPES = 'mediaTypes';
export const FILTER_CREATIVE_ORIENTATIONS = 'orientations';
export const FILTER_CREATIVE_REQUESTED_BY = 'requestedBy';
export const FILTER_CREATIVE_RESOLUTIONS = 'resolutions';
export const FILTER_CREATIVE_SIZES = 'sizes';
export const FILTER_CREATIVE_COLORS = 'colors';
export const FILTER_CREATIVE_AUTHORS = 'authors';
export const FILTER_CREATIVE_PRODUCTION_TYPES = 'productTypes';
export const FILTER_CREATIVE_ENHANCERS = 'enhancers';
export const FILTER_CREATIVE_INCLUDED_TAGS = 'includedTags';
export const FILTER_CREATIVE_EXCLUDED_TAGS = 'excludedTags';
export const FILTER_CREATIVE_OS = 'osIds';
export const FILTER_CREATIVE_CREATION_PERIOD = 'creationPeriod';
export const FILTER_CREATIVE_CONCEPT_CREATION_PERIOD = 'conceptCreationPeriod';
export const FILTER_CREATIVE_STATUSES = 'creativeStatuses';
export const FILTER_CREATIVE_END_CARD = 'endCardTypes';
export const FILTER_CREATIVE_TESTED = 'tested';
export const FILTER_IS_AI_CREATED = 'isAiCreated';

//  creative base dimensions
export const DIMENSION_CREATIVE = 'CreativeFile';
